<template>
  <div class="home">
    <div style="height: 6%; ">
      <span style="float: left;color: white;font-size: 10px;padding: 5px;">V1.24.1218.2

      </span>
      <router-link to="/managerLogin">
        <img src="../assets/admin1.png" alt="" style="width: 35px;
        height: 35px;float: right;">
      </router-link>
      
    </div>
    <div class="title_box">
      <span class="title">欢迎使用车牌自取信息登记系统</span>
    </div>
    <div class="text_box">
      <div style="height: 53%;"></div>
        <!-- <div style="width: 100%;
        height: 15%;font-size: 20px;font-weight: bold;">
          <van-tag style="height: 85%;width: 60%;" type="primary" color="#FF8C00"  round >
        <span style="margin: 0 auto;font-size: 20px;"> 注 意 事 项</span>
        </van-tag>
        </div> -->
      <div class="note_box">
      <div style="width: 90%; background-color: #f7f8f9;border-radius: 12px;">
        <!-- <div style="width: 100%;border: red 1px solid;
        height: 18%;font-size: 20px;font-weight: bold;">
          <van-tag style="height: 90%;width: 60%;" type="primary" color="#FF8C00"  round >
        <span style="margin: 0 auto;font-size: 20px;"> 注 意 事 项</span>
        </van-tag>
        </div> -->
        <van-divider
          :style="{ color: 'red', borderColor: 'red', padding: '0 16px',margin:'16px 0 0px 0',fontSize:'16px', }"
        >
          <h3>注 意 事 项</h3>
           <!-- <van-button @click="getParams">获取 url 参数</van-button> -->
        </van-divider>
        <van-steps direction="vertical" active-icon="warning" active-color="#FF0000" inactive-color="#FF0000" >

          <van-step>
            <h5 style="text-align: left;">如果是代取车牌，请登记代取人的身份信息</h5>
          </van-step>
          <van-step>
            <h5 style="text-align: left;">填写信息无法临时保存，填写完成后务必点击提交</h5>
          </van-step>
          <van-step>
            <h5 style="text-align: left;">如果内容填写错误，请重新扫码填写并提交</h5>
          </van-step>
        </van-steps>
        </div>
      </div>
    </div>
    <router-link to="/certMessage" >
      <van-button round type="info" style="width: 95%;margin-top: 2%;"> 开 始 登 记 </van-button>
    </router-link>
    <router-link to="/applyState" >
      <van-button round type="warning" style="width: 95%;margin-top: 4%;"> 取 牌 查 询 </van-button>
    </router-link>
  </div>
</template>

<script>
// @ is an alias to /src
import store from '@/store/index.js'

export default {
  name: 'Home',
  components: {
  },
  created(){
    // // 清空业务受理点代码 stCode 
    // store.commit('setUrlStationCode',null)
    // console.log('setUrlStationCode', store.state.urlStationCode)
  },
  mounted(){
    this.getParams()
  },
  methods:{
    getParams () {
      // const URL = 'https://sjzps.weelook.com?stcode=130100008159'
      // const URL = 'http://www.baidu.com?name=elephant&age=25&sex=male&num=100#smallpig'
      console.log(window.location.href);
      const URL = window.location.href
      this.queryURLParams(URL)
    },
    queryURLParams (url) {
      // 1.创建 a 标签
      const link = document.createElement('a')
      link.href = url
      const searchUrl = link.search.substring(1) // 获取问号后面的字符串
      const hashUrl = link.hash.substring(1) // 获取 # 后面的值
      const obj = {} // 声明参数对象
      // 2.向对象中进行存储
      hashUrl ? obj['HASH'] = hashUrl : null // # 后面是否有值
      const list = searchUrl.split('&')
      for (let i = 0; i < list.length; i++) {
        const arr = list[i].split('=')
        obj[arr[0]] = arr[1]
      }
      console.log('obj', obj)
      if(obj.stcode){
        // console.log('11111111');
        console.log('stcode',obj.stcode);
        
      }
      // 将业务受理点代码 stCode 保存到vuex中
      store.commit('setUrlStationCode',obj.stcode)
      console.log('setUrlStationCode', store.state.urlStationCode)
      // return obj
    }

  },
}
</script>
<style lang="scss" scoped>
.home{
  width: 100%;
  height: 667px;
  // background-image: url('../assets/background2.jpg');
  // background-size: 100% 100%;
  background-image: url('../assets/background2.jpg');
  background-size: cover; /* 背景图片覆盖整个容器 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-clip: content-box; /* 背景裁剪到内容区域 */
  .title_box{
        height: 8%;
        display: flex;
        align-items: center;
        // border: red 1px solid;
        justify-content: center;
        .title{
        // color: rgb(255, 251, 3);
        color: white;
        font-size: 25px;
        font-weight: bold;
    }
    }
    .text_box{
        height:65%;
        // border: red 1px solid;
        .note_box{
          height: 45%;
          // margin-top: -9%;
          display: flex;
          justify-content: center;
          // align-items: center;
          // border: blue 1px solid
        }
    }
    .van-steps{
      background-color: #f7f8f9;
    }
    // .van-divider{
    //   margin: 10px 0;
    // }
    // .van-step--vertical{
    //   padding: 9px 0;
    // }
    
}
</style>
